import { Command as CommandPrimitive } from "cmdk";
import { type ComponentProps } from "react";

export type CommandEmptyProps = typeof CommandPrimitive.Empty;

const Empty = ({ ref, ...props }: ComponentProps<CommandEmptyProps>) => (
  <CommandPrimitive.Empty ref={ref} className="px-3 py-6 text-center text-sm" {...props} />
);

Empty.displayName = CommandPrimitive.Empty.displayName;

export default Empty;
